import * as datesHelper from './dates';

export const STD_MONTH_FORMAT = /^\d{2,4} (jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)$/i;
export const STD_DATE_FORMAT = /^\d{2,4} (jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec) \d{1,2}$/i;
export const STD_DATE_RANGE_FORMAT = /^\d{2,4} (jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec) \d{1,2}-\d{2,4} (jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec) \d{1,2}$/i;


function getDateLabels(begin, end, formatter, next) {
  const dateLabels = [];
  const date = new Date(begin);
  while (date <= end) {
    dateLabels.push({
      x: datesHelper.epochDays(date),
      text: formatter(date),
    });
    next(date);
  }
  return dateLabels;
}

function formatYear(date, twoDigit = false) {
  const year = date.getFullYear().toString();
  return twoDigit ? `'${year.substr(2)}` : year;
}

function resolveAutoFormat(first, last) {
  if (last.getFullYear() - first.getFullYear() >= 4) {
    return 'year';
  } else if (first.getFullYear() === last.getFullYear() && last.getMonth() - first.getMonth() < 4) {
    return 'day';
  }
  return 'month';
}

function getFormatter(dateFormat, first, last) {
  const shortYear = dateFormat.indexOf('_yy') > -1;
  switch (dateFormat.replace('_yy', '')) {
    case 'auto':
      return getFormatter(`${resolveAutoFormat(first, last)}${shortYear ? '_yy' : ''}`, first, last);

    case 'year':
      return d => formatYear(d, shortYear);

    case 'quarter':
      return d => `Q${datesHelper.getQuarterFromMonth(d.getMonth())} ${formatYear(d, shortYear)}`;

    case 'month':
      if (last.getFullYear() - first.getFullYear() > 0) {
        return d => `${datesHelper.MONTH_NAMES[d.getMonth()]} ${formatYear(d, shortYear)}`;
      }
      return d => datesHelper.MONTH_NAMES[d.getMonth()];

    case 'day':
    default:
      if (last.getFullYear() - first.getFullYear() > 0) {
        return d => `${formatYear(d, shortYear)} ${datesHelper.MONTH_NAMES[d.getMonth()]} ${d.getDate()}`;
      }
      return d => `${datesHelper.MONTH_NAMES[d.getMonth()]} ${d.getDate()}`;
  }
}

export function parse(label) {
  const labelText = label.toString().trim();

  if (STD_DATE_FORMAT.test(labelText)) {
    return new Date(labelText);
  } else if (STD_MONTH_FORMAT.test(labelText)) {
    return new Date(`${labelText} 1`);
  } else if (STD_DATE_RANGE_FORMAT.test(labelText)) {
    return new Date(labelText.substr(labelText.indexOf('-') + 1));
  }

  return null;
}

export function format(date, dateFormat, first, last) {
  const shortYear = dateFormat.indexOf('_yy') > -1;
  let tickDate;

  switch (dateFormat.replace('_yy', '')) {
    case 'auto':
      return format(date, `${resolveAutoFormat(first, last)}${shortYear ? '_yy' : ''}`, first, last);

    case 'year':
      tickDate = new Date(date.getFullYear(), 0, 1);
      break;

    case 'quarter':
      tickDate = new Date(
        date.getFullYear(),
        (datesHelper.getQuarterFromMonth(date.getMonth()) - 1) * 3,
        1,
      );
      break;

    case 'month':
      tickDate = new Date(date.getFullYear(), date.getMonth(), 1);
      break;

    case 'day':
    default:
      tickDate = new Date(date);
  }

  return {
    x: datesHelper.epochDays(tickDate),
    text: getFormatter(dateFormat, first, last)(tickDate),
  };
}

export function formatAll(labels, dateFormat) {
  const shortYear = dateFormat.indexOf('_yy') > -1;
  const first = parse(labels[0].text);
  const last = parse(labels[labels.length - 1].text);
  let begin;
  let end;
  let next;

  switch (dateFormat.replace('_yy', '')) {
    case 'auto':
      return formatAll(labels, `${resolveAutoFormat(first, last)}${shortYear ? '_yy' : ''}`);

    case 'year':
      next = d => d.setFullYear(d.getFullYear() + 1);
      end = new Date(last.getFullYear(), 0, 1);

      if (first.getFullYear() < last.getFullYear()) {
        begin = first.getMonth() === 0 && first.getDate() === 1 ? first : new Date(first.getFullYear() + 1, 0, 1);
      } else {
        begin = new Date(last.getFullYear(), 0, 1);
      }
      break;

    case 'quarter':
      next = d => d.setMonth(d.getMonth() + 3);
      begin = (first.getMonth() + 1) % 4 === 0 && first.getDate() === 1
        ? first
        : new Date(first.getFullYear(), first.getMonth() + (3 - (first.getMonth() % 3)), 1);

      end = (last.getMonth() + 1) % 4 === 0 && last.getDate() === 1
        ? last
        : new Date(last.getFullYear(), last.getMonth() + (3 - (last.getMonth() % 3)), 1);
      break;

    case 'month':
      begin = first.getDate() === 1 ? first : new Date(first.getFullYear(), first.getMonth() + 1, 1);
      end = last.getDate() === 1 ? last : new Date(last.getFullYear(), last.getMonth(), 1);
      next = d => d.setMonth(d.getMonth() + 1);
      break;

    case 'day':
    default:
      begin = first;
      end = last;
      next = d => d.setDate(d.getDate() + 1);
  }

  if (end < begin) {
    end = begin;
  }

  return getDateLabels(begin, end, getFormatter(dateFormat, first, last), next);
}
